// a contract for mainnet, testnet, mocknet

import { Network } from './network';
import wallets from './constant-wallets';

type ContractMapping = Record<
  Network,
  { contract: string; owner: string; createLobby: string; joinLobby: string; urlLNSwap: string }
>;

export const contractMapping: ContractMapping = {
  mainnet: {
    contract: 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ.trustless-rewards',
    owner: 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ', // not used
    createLobby: 'create-lobby',
    joinLobby: 'join',
    urlLNSwap: 'https://widget.lnswap.org/widget.js',
  },
  testnet: {
    contract: 'ST1HW9QWHEQ7PZYQGGKJ8FRWBF6VAG7V885WYH3TQ.trustless-rewards', // profile Tester Contract Deployer
    owner: 'ST1HW9QWHEQ7PZYQGGKJ8FRWBF6VAG7V885WYH3TQ',
    createLobby: 'create-lobby',
    joinLobby: 'join',
    urlLNSwap: 'https://stacksdegens.com/widget.js',
  },
  mocknet: {
    contract: wallets.depoyer.wallet + '.trustless-rewards',
    owner: wallets.depoyer.wallet,
    createLobby: 'create-lobby',
    joinLobby: 'join',
    urlLNSwap: '',
  },
};

type ContractsNFT = Record<
  Network,
  { miamiDegens: string; nycDegens: string; sdguStacksPunks: string; bitcoinDegens: string }
>;

export const contractsNFT: ContractsNFT = {
  mainnet: {
    miamiDegens: 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ.miami-degens::miami-degens',
    nycDegens: 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ.nyc-degens::nyc-degens',
    sdguStacksPunks: 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ.SDGU-stackspunks::SDGU-stackspunks',
    bitcoinDegens: 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ.bitcoin-degens::bitcoin-degen',
  },
  testnet: {
    miamiDegens: 'ST1HW9QWHEQ7PZYQGGKJ8FRWBF6VAG7V885WYH3TQ.miami-degens::miami-degens',
    nycDegens: 'ST1HW9QWHEQ7PZYQGGKJ8FRWBF6VAG7V885WYH3TQ.nyc-degens::nyc-degens',
    sdguStacksPunks: '',
    bitcoinDegens: 'ST1HW9QWHEQ7PZYQGGKJ8FRWBF6VAG7V885WYH3TQ.bitcoin-degens-test-price-4::bitcoin-degen',
  },
  mocknet: {
    miamiDegens: 'ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.miami-degens::miami-degens',
    nycDegens: '',
    sdguStacksPunks: '',
    bitcoinDegens: '',
  },
};
